import React, { Component } from "react";
import { setStore, } from "Pub/js/storageUtils";
import { langCheck, getResolutionNumber, getLang } from "Pub/js/utils";
import "./index.less";



class ResolutionPrompt extends Component {
    constructor(props) {
        super(props);
        this.state = { downCount: 15 };
    }

    componentDidMount() {
        this.startCountDown();
    }

    componentWillUnmount() {
        this.closeCountDown();
    }

    startCountDown() {
        this.countDownInterval = setInterval(() => {
            let { downCount } = this.state;
            downCount--;
            if (downCount === 0) {
                this.closeCountDown(true);
                return;
            }
            this.setState({ downCount });
        }, 1000);
    }

    closeCountDown(close) {
        clearInterval(this.countDownInterval);
        if (close) {
            this.closePrompt();
            setStore('countDownCloseResolution', true); // 倒计时关闭标识
        }
    }

    // 关闭提示
    closePrompt() {
        const { closeResolutionprompt } = this.props;
        closeResolutionprompt && closeResolutionprompt();
        PubSub.publish('closeResolutionprompt');
    }

    know = () => {
        this.closePrompt();
        setStore('zoomValue', { show1: false });
    }
    render() {
        const { downCount } = this.state;
        return <div className={`resolution-prompt`}>
            <div className='bg'>
                <div className='resolution-prompt-container'>
                    <div className='left-box'>
                        <div className='line'></div>
                        <i className='iconfont icon-zhuyi1'></i>
                        {/* <p>{getLang(langCheck("0000PUB-000597"), { num: getResolutionNumber() || 0 })}</p> */}
                        <p>{langCheck("0000PUB-000597")}</p>
                        {/* <span className='has-border'>Ctrl</span>
                        <span className='no-border'>+</span>
                        <span className='has-border'>-</span> */}
                    </div>
                    <div className="right-box">
                        <span className="count-down">{langCheck('0000PUB-000632', false, null, [ downCount ] )}</span>
                        <span className='btn' onClick={this.know}>{langCheck("0000PUB-000598")}</span>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default ResolutionPrompt;